import gql from 'graphql-tag';

export default gql`
    query homepage($articleLimit: Int) {
        homepage {
            ... on Homepage {
                h1TitleTag
                brandHeadline
                heroImage {
                    altText
                    url
                    focalPoint
                }
                contentBlock {
                    ... on ArticleCollection {
                        title
                        description
                        contentType
                        seeMoreLink {
                            buttonLabel
                            buttonUrl
                            category
                        }
                        articles(limit: $articleLimit) {
                            items {
                                heroImage {
                                    altText
                                    focalPoint
                                    url
                                }
                                id
                                slug
                                snippet
                                title
                                publicationDateAndTime
                                category {
                                    slug
                                }
                            }
                        }
                    }
                    ... on CampaignCta {
                        contentType
                        ccTitle: title
                        ccDescription: description
                        image {
                            url
                            altText
                            focalPoint
                        }
                    }
                    ... on Banner {
                        title
                        bannerDescription: description {
                            content
                            data
                        }
                        buttons {
                            buttonLabel
                            buttonUrl
                            category
                        }
                        backgroundColour
                        imagePosition
                        imageSrc
                        contentType
                    }
                }
            }
            ... on CMSError {
                errorCode
            }
        }
    }
`;
